import api from '../api'
import { setLiveConfigurationCache } from '../utils/configuration/configurationCache'

// eslint-disable-next-line import/prefer-default-export
export function fetchConfiguration() {
  return (dispatch, getState) => api.fetch('/configuration')
    .then((response) => {
      const payload = {
        ...response,
        fetchedAt: new Date(),
      }
      const { initialConfiguration } = getState()
      if (!initialConfiguration) {
        dispatch({
          type: 'FETCH_INITIAL_CONFIGURATION_SUCCESS',
          response: payload,
        })
      }
      dispatch({
        type: 'FETCH_CONFIGURATION_SUCCESS',
        response: payload,
      })

      setLiveConfigurationCache(payload)
    })
    .catch((error) => error)
}
